"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const SvgMentions = (props) => ((0, jsx_runtime_1.jsx)("svg", Object.assign({ "data-testid": "ICON_MENTIONS", width: "1em", height: "1em", viewBox: "0 0 16 16" }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: "M0 8a8 8 0 0 0 8 8 1 1 0 1 0 0-2 6 6 0 1 1 5.659-4h-2.194A4 4 0 1 0 8 12h6.353a.931.931 0 0 0 .847-.51A8 8 0 1 0 0 8Zm8 2a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z" }) })));
exports.default = SvgMentions;
